var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgErrorTriangle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 8,
    fill: "#F9E1E0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.8935 10.1884L8.68036 3.92753C8.53836 3.65083 8.28402 3.4856 7.99998 3.4856C7.71595 3.4856 7.4616 3.6508 7.3196 3.92753L4.10652 10.1884C3.96449 10.4651 3.96449 10.7955 4.10652 11.0723C4.24856 11.349 4.50287 11.5142 4.78691 11.5142H11.2132C11.4972 11.5142 11.7515 11.349 11.8935 11.0723C12.0355 10.7956 12.0355 10.4652 11.8935 10.1884ZM8.00002 10.4956C7.71803 10.4956 7.48863 10.2376 7.48863 9.92033C7.48863 9.60313 7.71803 9.34505 8.00002 9.34505C8.282 9.34505 8.51141 9.60313 8.51141 9.92033C8.51137 10.2376 8.28197 10.4956 8.00002 10.4956ZM8.51485 8.03643C8.51485 8.35578 8.28389 8.61562 8.00002 8.61562C7.71615 8.61562 7.48518 8.35578 7.48518 8.03643V5.37817C7.48518 5.22665 7.59437 5.10381 7.72905 5.10381H8.27101C8.40573 5.10381 8.51489 5.22665 8.51489 5.37817V8.03643H8.51485Z",
    fill: "#E26982"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorTriangle);
export default __webpack_public_path__ + "static/media/error-triangle.f0c264be.svg";
export { ForwardRef as ReactComponent };